<mat-card class="settingsBody">
    <mat-card-header>
        <mat-card-title class="settings-heading">Scheduled Reports</mat-card-title>
    </mat-card-header>
    <mat-tab-group
        #example1
        ActiveTabIndex="tab"
        (selectedTabChange)="handleTabChange($event)"
        useAutomaticActivation
        class="settings"
    >
        <mat-tab [label]="'Exports'" class="settings"></mat-tab>
        <mat-tab [label]="'Schedules'" class="settings"></mat-tab>
    </mat-tab-group>
    <br />

    <!-- Notification History -->
    <ng-container *ngIf="tab === 0">
        <kendo-grid
            #grid="kendoGrid"
            [loading]="loadingExports"
            [data]="exportsGrid"
            [pageSize]="pageSizeE"
            [scrollable]="false"
            [height]="750"
            class="lg-kendo-grid"
            [skip]="skipE"
            [pageable]="{
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true
            }"
            (pageChange)="pageChangeExports($event)"
        >
            <kendo-grid-column field="module" title="Module" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.module | titlecase }}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="reportName" title="Report"> </kendo-grid-column>

            <kendo-grid-column field="displayOptionText" title="Display Options">
            </kendo-grid-column>

            <kendo-grid-column field="filterText" title="Filters"> </kendo-grid-column>

            <kendo-grid-column field="frequency" title="Frequency" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container [ngSwitch]="dataItem.frequency">
                        <span *ngSwitchCase="2">Weekly</span>
                        <span *ngSwitchCase="3">Monthly</span>
                        <span *ngSwitchDefault>Daily</span>
                    </ng-container>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="enterDt" title="Date" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.enterDt | date }}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Download">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button
                        mat-stroked-button
                        color="basic"
                        [disabled]="dataItem.loading"
                        (click)="download(dataItem)"
                    >
                        Download
                    </button>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </ng-container>

    <!-- Notification Settings -->
    <ng-container *ngIf="tab === 1">
        <kendo-grid
            #grid="kendoGrid"
            [loading]="loadingSchedules"
            [data]="schedulesGrid"
            [pageSize]="pageSizeS"
            [skip]="skipS"
            [scrollable]="false"
            [pageable]="{
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true
            }"
            (pageChange)="pageChangeSchedules($event)"
            [height]="750"
            class="lg-kendo-grid"
        >
            <kendo-grid-column field="module" title="Module" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.module | titlecase }}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="reportName" title="Report"> </kendo-grid-column>

            <kendo-grid-column field="displayOptionText" title="Display Options">
            </kendo-grid-column>

            <kendo-grid-column field="filterText" title="Filters"> </kendo-grid-column>

            <kendo-grid-column field="frequency" title="Frequency" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container [ngSwitch]="dataItem.frequency">
                        <span *ngSwitchCase="2">Weekly</span>
                        <span *ngSwitchCase="3">Monthly</span>
                        <span *ngSwitchDefault>Daily</span>
                    </ng-container>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="dayOfWeek" title="Day" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ getDayOfWeek(dataItem.dayOfWeek) }}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="hour" title="Time" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ getHour(dataItem) }}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Delete">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button mat-stroked-button color="warn" (click)="cancelConfirm(dataItem)">
                        Delete
                    </button>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </ng-container>
</mat-card>
